























import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import { NotificationItem } from '@/mixins/requests/admin/NotificationApis.vue'

@Component({
  components: {
    ButtonBase,
  },
})
export default class NotificationTable extends Vue {
  /** お知らせ一覧 */
  @Prop()
  private notificationItems!: NotificationItem[] | null
  /** クリック：お知らせ件名ラベル */
  @Prop()
  private onClickTitleLabel!: (notificationId: number) => Promise<void>
  /** クリック：削除ボタン */
  @Prop()
  private onClickDeleteButton!: (notificationId: number) => Promise<void>

  /**
   * お知らせ存在判定
   */
  private get isExistNotification(): boolean {
    if (this.notificationItems === null) return false

    return this.notificationItems.length > 0
  }

  /**
   * 値が設定されていない場合の表示対応
   */
  private displayFieldItem(item: string): string {
    return item || '—'
  }
}
